// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var BackupSettingsController = function ($scope, BackupSettings) {
    $scope.settingsLoaded = false;
    BackupSettings.get().$promise.then(function (response) {
        $scope.backupSettings = response;
        $scope.settingsLoaded = true;
    });
    $scope.save = function () {
        $scope.backupSettings.$update({}, function () {
            $scope.notifySuccess();
        });
    };
};
BackupSettingsController.$inject = ['$scope', 'BackupSettings'];
